<script setup>
import { VDataTable } from "vuetify/labs/VDataTable";
import { withQuery } from "ufo";

const deleteDialog = ref(false);

definePage({
  meta: {
    layout: "default",
  },
});
const route = useRoute();
const router = useRouter();

const pageTitle = "Permission & Role";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/role",
  },
  {
    title: route.params.id,
    to: null,
  },
];

const { data: dataQuery } = await useApi(
  withQuery("/cms/roles/" + route.params.id + "?id=" + route.params.id, {
    method: "GET",
  })
);
const data = dataQuery ? dataQuery.value?.data : [];

const roleHeader = [
  {
    title: "Function ID",
    key: "functionId",
  },
  {
    title: "Description",
    key: "description",
  },
  {
    title: "Execution",
    key: "execute",
  },
];
const authorityHeader = [
  {
    title: "Place No",
    key: "id",
  },
  {
    title: "Description",
    key: "description",
  },
  {
    title: "Execution",
    key: "execute",
  },
];

const functionCard = ref(false);
const functionCardId = ref("");
const functionCardDesc = ref("");
const functionCardData = ref([]);
const openFunctionCard = (id, desc, items) => {
  functionCard.value = true;
  functionCardId.value = id;
  functionCardDesc.value = desc;
  functionCardData.value = items;
};
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }} Detail</h4>
  <VRow>
    <VCol class="align-items-stretch" cols="12" lg="12" sm="12">
      <VCard border class="v-card-data" title="Role Information">
        <template #append>
          <VBtn
            :to="{ path: '/admin/role/update/' + route.params.id }"
            block
            color="primary"
          >
            <VIcon icon="tabler-pencil" start />
            Edit {{ pageTitle }}
          </VBtn>
        </template>

        <VTable class="text-no-wrap" density="compact">
          <tbody>
            <tr>
              <td>Role ID</td>
              <td>{{ data.id }}</td>
            </tr>
            <tr>
              <td>Role name</td>
              <td>{{ data.name }}</td>
            </tr>
            <tr>
              <td>Role Description</td>
              <td>{{ data.description }}</td>
            </tr>
          </tbody>
        </VTable>
        <div v-show="data.type == 'issuer'">
          <VDivider />
          <VCardTitle class="my-4 mx-2">Function Information</VCardTitle>
          <VCardText>
            <VRow>
              <VCol cols="12" lg="6">
                <VCard border>
                  <VDataTable
                    :headers="roleHeader"
                    :items="data.permissions"
                    border
                    class="py-5"
                  >
                    <template #item.functionId="{ item }">
                      <div
                        class="text-primary cursor-pointer"
                        @click="
                          openFunctionCard(
                            item.functionId,
                            item.description,
                            item.authority
                          )
                        "
                      >
                        {{ item.functionId }}
                      </div>
                    </template>
                  </VDataTable>
                </VCard>
              </VCol>
              <VCol cols="12" lg="6">
                <VCard v-if="functionCard">
                  <VCardText>
                    <h6 class="text-h6">Function ID | {{ functionCardId }}</h6>
                    <p class="text-secondary">
                      {{ functionCardDesc }}
                    </p>
                    <h4 class="text-h4 my-4">Authority List</h4>
                    <VCard border>
                      <VDataTable
                        :headers="authorityHeader"
                        :items="functionCardData"
                        border
                        class="py-5"
                      />
                    </VCard>
                  </VCardText>
                </VCard>
              </VCol>
            </VRow>
          </VCardText>
        </div>
      </VCard>
      <div class="mx-auto text-center">
        <VBtn
          :to="{ path: '/admin/role' }"
          class="mt-5 mx-auto text-center"
          color="secondary"
        >
          <VIcon icon="tabler-refresh" start />
          Back to {{ pageTitle }} List
        </VBtn>
      </div>
    </VCol>
  </VRow>
</template>
